module.exports = __webpack_public_path__ + "Star-no-review.59ba451c460f84c3aed1c233236763b3.png";